<template>
<section class="homeAbout">
  <div class="homeAbout-titlebox">
    <h2>Ian Hurdle RE<br/> Advisor in the<br/>Caribbean</h2>
  </div>
  <div class="homeAbout-descrbox" id="about">
    <h2>Ian Hurdle RE<br/> Advisor in the<br/>Caribbean</h2>
    <p>
      One of the top agents serving the Caribbean's luxury markets,
      <b> Ian hurdle brings more than 30 years of experience</b>
      in the real estate, construction, property management, and hospitality industries to his role as Founder and Director of The Agency Caribbean.
    </p>
    <p>
      The Agency is a full-service, luxury real estate brokerage and lifestyle company representing clients worldwide in a broad spectrum of classes, including residential, new development, resort real estate, residential leasing and luxury vacation rentals.
    </p>
  </div>
  <div class="homeAbout-photobox">
    <img class="homeAbout-photo" alt="" src="@/assets/images/ian.jpg" />
  </div>
  <div class="homeAbout-infobox">
    <div class="homeAbout-info">
      <div class="info-text">$50M+</div>
      <div class="info-desc">sales volume in 2025</div>
    </div>
    <div class="homeAbout-info">
      <div class="info-text">$300M+</div>
      <div class="info-desc">total sales volume</div>
    </div>
    <div class="homeAbout-info">
      <div class="info-text">$200M+</div>
      <div class="info-desc">current active listings</div>
    </div>
    <div class="homeAbout-info">
      <div class="info-text">5+</div>
      <div class="info-desc">chairman award winner</div>
    </div>
  </div>
</section>
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      // DrawLine: () => import('@/components/DrawLine'),
    },
  };
</script>

<style lang="scss">
  .homeAbout {
    display: contents;
    &-titlebox {
      padding-top: 64px;
      padding-bottom: 16px;
      color: #1F1E1E;

      h2{
        font-family: 'Abhaya Libre';
        font-weight: 800;
        
        text-align: left;
      }
      
      @include tablet {
        /* padding-top: 56px;
        padding-bottom: 32px;
        text-align: center; */
      }
      @include phone {
        h2 {
          font-size: 42px;
          /* line-height: 29px; */
        }
      }
    }
    &-logobox {
      padding-top: 150px;
      padding-bottom: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      @include tablet {
        padding-top: 20px;
        padding-bottom: 20px;
        .svg-luxury {
          transform-origin: center;
          transform: scale(0.8);
        }
      }
    }
    &-descrbox {
      h2 {
      font-size: 72px;
      line-height: 72px;  
      font-family: "Abhaya Libre";
      font-weight: 800;
      color: #1F1E1E;
      }
     
      font-size: 18px;
      line-height: 32px;
      padding-top: 130px;
      display: flex;
      flex-direction: column;
      padding-right: 50px;
      @include gap(30px, col);
       p {
        margin-top: 30px;
      }

      @include large {
        @include gap(30px, col);
      }

      @include middle {
        padding-top: 60px;
        font-size: 18px;
        padding-right: 60px;
      }

      

      @include tablet {
        padding-top: 40px;
        
        @include gap(16px, col);
        justify-content: center;
        padding-right: 20px;
        padding-bottom: 60px;
        h2 {
          font-size: 50px;
          line-height: 50px;
        }


        br {
          /* display: none; */
        }
      }


      @include miniTablet {
        
        width: 95%;
        padding-right: 0px;
        
      }



      @include phone {
        padding-bottom: 25px;
        padding-top: 25px;
        padding-right: 0px;
        h2 {
          font-size: 24px;
          line-height: 29px;
          display:none;
        }
      }

      p {
        @include tablet {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    &-photobox {
      height: 750px;
      margin-bottom: 120px;
      margin-top: 42px;
      img{
        width: 100%;
        height: 100%;
        
      }
      @include middle {
        /* height: 480px; */
        margin-bottom: 180px;
      }

      @include small {
        height: auto;
        margin-bottom: 120px;
      }
      @include tablet {
        margin-top: 40px;
        height: auto;
        margin: 40px 0;
       
      }

      @include miniTablet {
        height: 430px;
        
      }

      @include phone {

        height: 100vw;
        margin-bottom: 0px;
        margin-top: 0;
      }
    }
    &-photo {
      width: 100%;
      height: 100%;
      object-fit: cover;
      @include phone {
         /* top: 0; */
      }
    }

    &-infobox{
      display: flex;
      justify-content: space-between;
      margin-bottom: 120px;

      @include tablet {
        
         
         .homeAbout-info{
         .info-text {
            font-size: 60px;
          }
         }
         
        
      }

      @include phone {
        flex-direction: column;
        margin-bottom: 32px;
        gap: 32px;
       }
      
    }
    &-info{
      font-family: "Abhaya Libre";
      .info-text{
        font-size: 86px;
        font-weight: 500;
        margin-bottom: 6px;
        color: #1F1E1E;
      }
      .info-desc{
        font-size: 18px;
        font-weight: 800;
        color: #D41E34
      }

      @include phone {
        text-align: center;


        &:first-of-type{
          order: 2;
          
        }

        &:nth-of-type(2){
          order: 1;
        }

        &:nth-of-type(3){
          order: 4;
        }

        &:last-of-type{
          order: 3
        }
        .info-text{
          font-size: 60px;
          line-height: 60px;
        }
        .info-desc{
          font-size: 16px;
          line-height: 20px;
          margin-top: 6px;

          @include phone {
            font-family: "Proxima Nova";
            font-weight: 400;
          }
        }
       }
      
    }
  }
</style>
